var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconReloadWhite = function SvgIconReloadWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 2a9.97 9.97 0 0 0-7.195 3.055l1.439 1.39A8 8 0 0 1 20 12h2V4h-2v1.999A9.99 9.99 0 0 0 12 2M4 18.001A9.99 9.99 0 0 0 12 22a9.97 9.97 0 0 0 6.945-2.805l-1.39-1.439A8 8 0 0 1 4 12H2v8h2z",
    "data-follow-fill": "currentColor"
  })));
};
export default SvgIconReloadWhite;